import * as sterlingparker from './PropositionButton.styles.sterlingparker';
import * as volcanobet from './PropositionButton.styles.volcanobet';
import * as betprofessor from './PropositionButton.styles.betprofessor';
import * as puntgenie from './PropositionButton.styles.puntgenie';
import * as junglebet from './PropositionButton.styles.junglebet';
import * as fiestabet from './PropositionButton.styles.fiestabet';
import * as puntcity from './PropositionButton.styles.puntcity';
import * as betgalaxy from './PropositionButton.styles.betgalaxy';
import * as betroyale from './PropositionButton.styles.betroyale';
import * as juicybet from './PropositionButton.styles.juicybet';
import * as goldenrush from './PropositionButton.styles.goldenrush';
import * as vikingbet from './PropositionButton.styles.vikingbet';
import * as questbet from './PropositionButton.styles.questbet';
import * as wellbet from './PropositionButton.styles.wellbet';
import * as sugarcastle from './PropositionButton.styles.sugarcastle';
import * as oldgill from './PropositionButton.styles.oldgill';
import * as buffalobet from './PropositionButton.styles.buffalobet';
import * as titanbet from './PropositionButton.styles.titanbet';
import * as gigabet from './PropositionButton.styles.gigabet';
import * as slambet from './PropositionButton.styles.slambet';
import * as betstride from './PropositionButton.styles.betstride';
import * as templebet from './PropositionButton.styles.templebet';
import * as goldenbet888 from './PropositionButton.styles.goldenbet888';
import * as hyperbet from './PropositionButton.styles.hyperbet';
import * as bet777 from './PropositionButton.styles.bet777';
import * as chromabet from './PropositionButton.styles.chromabet';
import * as bet575 from './PropositionButton.styles.bet575';
import * as betblast from './PropositionButton.styles.betblast';
import * as pyramidbet from './PropositionButton.styles.pyramidbet';
import * as magnumbet from './PropositionButton.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sterlingparker,
  volcanobet,
  betprofessor,
  puntgenie,
  junglebet,
  fiestabet,
  puntcity,
  betgalaxy,
  betroyale,
  juicybet,
  goldenrush,
  vikingbet,
  questbet,
  wellbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
